export default `
mutation cancelOrder($orderId: String!, $message: String!) {
    cancelOrder(input: {
        order_id: $orderId
        reason: $message
    }) {
        status
        message
    }
}  
`;